import { deepEqual } from "@costar-search-x/core";
import { useCallback } from "react";
export const useCanClearSearch = <Criteria>(
  initialCriteria: Criteria | undefined,
  isCriteriaValid: (criteria: Criteria) => boolean
) => {
  return useCallback(
    (criteria: Criteria) => {
      if (isCriteriaValid(criteria)) {
        return !deepEqual(initialCriteria, criteria);
      }

      return false;
    },
    [initialCriteria, isCriteriaValid]
  );
};
